import React from 'react'

const Loader = () => {
  return (
    
<div className="loader">
      <div className="loader-before"></div>
      <div className="loader-after"></div>
    </div>
  )
}

export default Loader